// eslint-disable-next-line import/prefer-default-export
export const debounceInterval = 2000;
